import {
  Component,
  ComponentFactoryResolver,
  ViewContainerRef,
  OnInit,
  ComponentRef,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UiService } from "src/app/ui/ui.service";
import { FlowNodeController, SideBarItem } from "../../flow-node.controller";
import { FlowsService } from "../../flows.service";
import { FollowUpNodeMenuComponent } from "./follow-up-node-menu/follow-up-node-menu.component";

@Component({
  selector: "app-follow-up-node",
  templateUrl: "./follow-up-node.component.html",
  styleUrls: ["./follow-up-node.component.scss"],
})
export class FollowUpNodeComponent extends FlowNodeController implements OnInit
{
  channelItems?: SideBarItem[];
  onFollowUpNodeSelected = new Subject<SideBarItem>();
  constructor(
    factoryResolver: ComponentFactoryResolver,
    ViewContainerRef: ViewContainerRef,
    FlowsService: FlowsService,
    Router: Router,
    uiService: UiService,
    MatDialog: MatDialog,
  ) {
    super(
      factoryResolver,
      ViewContainerRef,
      FlowsService,
      Router,
      uiService,
      MatDialog,
    );
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();

    //console.log('Follow-Up Node Init Start', this.channelItems)

    const factory = this.factoryResolver.resolveComponentFactory(
      FollowUpNodeMenuComponent,
    );
    this.menuComponent = factory.create(
      this.flowMenuViewContainerRef.parentInjector,
    ) as ComponentRef<FollowUpNodeMenuComponent>;
    this.menuComponent.instance.node = this.node;
    this.menuComponent.instance.selected = this.selected;
    this.menuComponent.instance.onMenuSizeChange = this.onMenuSizeChange;
    (this.menuComponent.instance as FollowUpNodeMenuComponent).channelItems = this.channelItems ?? [];
    (this.menuComponent.instance as FollowUpNodeMenuComponent).onFollowUpNodeSelected = this.onFollowUpNodeSelected;
    this.flowMenuViewContainerRef.insert(this.menuComponent.hostView);

    this.menuComponent.instance.onNodeMenuInstantiated
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(() => {
        this.onMenuInstantiated.next();
        this.onMenuInstantiated.complete();
        this.onNodeReady.emit(this.componentRef);
      });

    this.onFollowUpNodeSelected
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((followUpNode) => {
        followUpNode.onFlowAreaClick!(
          {
            currentItem: followUpNode,
            x: this.node.left! + 40,
            y: this.node.top! + 40,
          },
          true,
          true,
        );

        this.deleteNode();
      });

      //console.log('Follow-Up Node Init End')

  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  get canBeConnectedTo() {
    return false;
  }
}
